import { useEffect, useState } from 'react';

const defaultParse = <T,>(raw: string): T => JSON.parse(raw);
const defaultSerialize = <T,>(value: T): string => JSON.stringify(value);

// Shared implementation behind the useShow*/use*Only/useMinLevel/useHiddenFacilities
// hooks - they all just persist one piece of filter state to localStorage.
export const useLocalStorageState = <T,>(
	storageKey: string,
	defaultValue: T,
	parse: (raw: string) => T = defaultParse,
	serialize: (value: T) => string = defaultSerialize
) => {
	const readValue = (): T => {
		if (typeof window === 'undefined') {
			return defaultValue;
		}

		try {
			const storedValue = window.localStorage.getItem(storageKey);
			if (storedValue === null) {
				return defaultValue;
			}

			return parse(storedValue);
		} catch {
			return defaultValue;
		}
	};

	const [value, setValue] = useState<T>(readValue);

	useEffect(() => {
		if (typeof window === 'undefined') {
			return;
		}

		window.localStorage.setItem(storageKey, serialize(value));
	}, [storageKey, value, serialize]);

	return [value, setValue] as const;
};
